





















































































import { Component, Vue, PropSync } from 'vue-property-decorator';

@Component({
  components: {},
  filters: {},
})
export default class HonoModal extends Vue {
  @PropSync('active', { default: false })
  pActive!: boolean;
}
